import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import LazyImage from '../components/LazyImage/LazyImage';
import { LocationIcon, BedIcon, BathIcon, AreaIcon, PhoneIcon, EmailIcon, CheckIcon, ArrowLeftIcon, ShareIcon, HeartIcon } from '../components/Icons/Icons';
import './RentalDetail.css';

function RentalDetail() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I am interested in this rental property. Please provide more details.'
  });

  // Mock rental property data
  const property = {
    id: 1,
    title: '3 Bedroom Luxury Apartment for Rent',
    location: 'DHA Phase 5, Karachi',
    city: 'Karachi',
    type: 'Apartment',
    price: '75,000',
    deposit: '150,000',
    bedrooms: 3,
    bathrooms: 3,
    area: '1400',
    furnished: 'Furnished',
    floor: '4th Floor',
    totalFloors: '12',
    availableFrom: 'Immediate',
    leaseTerm: 'Minimum 1 Year',
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80',
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
    ],
    description: `This stunning 3-bedroom apartment offers modern luxury living in one of Karachi's most sought-after neighborhoods. Located on the 4th floor of a well-maintained building, this fully furnished unit spans 1400 square feet of contemporary design.

The apartment features an open-plan living and dining area with large windows providing abundant natural light and city views. The modern kitchen comes fully equipped with high-quality appliances and ample storage space.

All three bedrooms are spacious with built-in wardrobes, and the master bedroom includes an en-suite bathroom. The property is situated in a secure building with 24/7 security, elevator access, and dedicated parking.

Perfect for families or professionals seeking a comfortable, move-in ready home in a prime location with easy access to schools, shopping centers, restaurants, and major roads.`,
    amenities: [
      'Furnished',
      'Air Conditioning',
      'Built-in Wardrobes',
      'Central Heating',
      'Balcony',
      'Elevator',
      'Parking',
      '24/7 Security',
      'Backup Generator',
      'Water Supply',
      'Waste Disposal',
      'Maintenance Staff'
    ],
    nearbyPlaces: [
      { name: 'Aga Khan Hospital', distance: '1.5 km', type: 'Hospital' },
      { name: 'Dolmen Mall', distance: '2 km', type: 'Shopping' },
      { name: 'The Lyceum School', distance: '1 km', type: 'School' },
      { name: 'Sunset Boulevard', distance: '3 km', type: 'Food Street' }
    ],
    landlord: {
      name: 'Ahmed Khan',
      phone: '+92 300 1234567',
      email: 'ahmed.khan@pakmilkiyat.com',
      whatsapp: '+92 300 1234567',
      responseTime: 'Within 2 hours'
    },
    includedUtilities: ['Water', 'Garbage Collection', 'Building Maintenance'],
    notIncluded: ['Electricity', 'Gas', 'Internet'],
    postedDate: '3 days ago',
    viewCount: 456
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? property.images.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === property.images.length - 1 ? 0 : prev + 1
    );
  };

  const handleSubmitInquiry = (e) => {
    e.preventDefault();
    console.log('Inquiry submitted:', formData);
    alert('Thank you for your inquiry! The landlord will contact you soon.');
    setShowContactForm(false);
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: 'I am interested in this rental property. Please provide more details.'
    });
  };

  return (
    <div className="rental-detail-page">
      <Header />

      <div className="rental-detail-container">
        <button
          className="back-button"
          onClick={() => window.navigateTo && window.navigateTo('rent')}
        >
          <ArrowLeftIcon size={20} color="#2c3e50" />
          Back to Listings
        </button>

        <div className="rental-detail-content">
          <div className="rental-main-content">
            <div className="rental-gallery">
              <div className="main-image-container">
                <LazyImage
                  src={property.images[currentImageIndex]}
                  alt={property.title}
                  className="main-rental-image"
                  aspectRatio="16/9"
                />
                <button className="gallery-btn gallery-prev" onClick={handlePrevImage}>
                  ❮
                </button>
                <button className="gallery-btn gallery-next" onClick={handleNextImage}>
                  ❯
                </button>
                <div className="image-counter">
                  {currentImageIndex + 1} / {property.images.length}
                </div>
              </div>
              <div className="thumbnail-strip">
                {property.images.map((image, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  >
                    <LazyImage
                      src={image}
                      alt={`View ${index + 1}`}
                      aspectRatio="4/3"
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="rental-header">
              <div className="rental-title-section">
                <h1 className="rental-title">{property.title}</h1>
                <div className="rental-actions">
                  <button className="action-btn">
                    <ShareIcon size={20} color="#636e72" />
                  </button>
                  <button className="action-btn">
                    <HeartIcon size={20} color="#636e72" />
                  </button>
                </div>
              </div>
              <div className="rental-location">
                <LocationIcon size={18} color="#636e72" />
                <span>{property.location}</span>
              </div>
              <div className="rental-meta">
                <span className="rental-badge">{property.furnished}</span>
                <span className="rental-meta-text">Posted {property.postedDate}</span>
                <span className="rental-meta-text">{property.viewCount} views</span>
              </div>
            </div>

            <div className="rental-price-card">
              <div className="price-main">
                <span className="price-label">Monthly Rent</span>
                <span className="price-amount">PKR {property.price}</span>
              </div>
              <div className="price-secondary">
                <span className="price-label">Security Deposit</span>
                <span className="price-amount">PKR {property.deposit}</span>
              </div>
            </div>

            <div className="rental-features">
              <div className="feature-item">
                <BedIcon size={24} color="var(--color-primary)" />
                <div className="feature-info">
                  <span className="feature-label">Bedrooms</span>
                  <span className="feature-value">{property.bedrooms}</span>
                </div>
              </div>
              <div className="feature-item">
                <BathIcon size={24} color="var(--color-primary)" />
                <div className="feature-info">
                  <span className="feature-label">Bathrooms</span>
                  <span className="feature-value">{property.bathrooms}</span>
                </div>
              </div>
              <div className="feature-item">
                <AreaIcon size={24} color="var(--color-primary)" />
                <div className="feature-info">
                  <span className="feature-label">Area</span>
                  <span className="feature-value">{property.area} sqft</span>
                </div>
              </div>
            </div>

            <div className="rental-section">
              <h2 className="section-title">Description</h2>
              <p className="rental-description">{property.description}</p>
            </div>

            <div className="rental-section">
              <h2 className="section-title">Property Details</h2>
              <div className="details-grid">
                <div className="detail-row">
                  <span className="detail-label">Property Type</span>
                  <span className="detail-value">{property.type}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Floor</span>
                  <span className="detail-value">{property.floor} of {property.totalFloors}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Furnished Status</span>
                  <span className="detail-value">{property.furnished}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Available From</span>
                  <span className="detail-value">{property.availableFrom}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Lease Term</span>
                  <span className="detail-value">{property.leaseTerm}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Area Size</span>
                  <span className="detail-value">{property.area} sqft</span>
                </div>
              </div>
            </div>

            <div className="rental-section">
              <h2 className="section-title">Amenities & Features</h2>
              <div className="amenities-grid">
                {property.amenities.map((amenity, index) => (
                  <div key={index} className="amenity-item">
                    <CheckIcon size={18} color="var(--color-primary)" />
                    <span>{amenity}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rental-section">
              <h2 className="section-title">Utilities</h2>
              <div className="utilities-container">
                <div className="utilities-group">
                  <h3 className="utilities-subtitle">Included in Rent</h3>
                  <ul className="utilities-list">
                    {property.includedUtilities.map((utility, index) => (
                      <li key={index}>
                        <CheckIcon size={16} color="var(--color-primary)" />
                        {utility}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="utilities-group">
                  <h3 className="utilities-subtitle">Not Included (Tenant Pays)</h3>
                  <ul className="utilities-list not-included">
                    {property.notIncluded.map((utility, index) => (
                      <li key={index}>
                        <span className="bullet">•</span>
                        {utility}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="rental-section">
              <h2 className="section-title">Nearby Places</h2>
              <div className="nearby-places">
                {property.nearbyPlaces.map((place, index) => (
                  <div key={index} className="nearby-item">
                    <div className="nearby-info">
                      <span className="nearby-name">{place.name}</span>
                      <span className="nearby-type">{place.type}</span>
                    </div>
                    <span className="nearby-distance">{place.distance}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="rental-sidebar">
            <div className="landlord-card">
              <h3 className="landlord-title">Contact Landlord</h3>
              <div className="landlord-info">
                <div className="landlord-name">{property.landlord.name}</div>
                <div className="landlord-response">
                  Response Time: {property.landlord.responseTime}
                </div>
              </div>

              <div className="contact-buttons">
                <a href={`tel:${property.landlord.phone}`} className="contact-btn phone-btn">
                  <PhoneIcon size={20} color="#ffffff" />
                  Call Now
                </a>
                <a href={`https://wa.me/${property.landlord.whatsapp.replace(/\s/g, '')}`} className="contact-btn whatsapp-btn">
                  <PhoneIcon size={20} color="#ffffff" />
                  WhatsApp
                </a>
                <a href={`mailto:${property.landlord.email}`} className="contact-btn email-btn">
                  <EmailIcon size={20} color="#ffffff" />
                  Email
                </a>
              </div>

              <button
                className="inquiry-btn"
                onClick={() => setShowContactForm(!showContactForm)}
              >
                Send Inquiry
              </button>

              {showContactForm && (
                <form className="contact-form" onSubmit={handleSubmitInquiry}>
                  <input
                    type="text"
                    placeholder="Your Name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                  <input
                    type="tel"
                    placeholder="Your Phone"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                  <textarea
                    placeholder="Your Message"
                    rows="4"
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  />
                  <button type="submit" className="submit-btn">Send Message</button>
                </form>
              )}
            </div>

            <div className="safety-tips-card">
              <h3 className="tips-title">Safety Tips</h3>
              <ul className="tips-list">
                <li>Always visit the property before making any payment</li>
                <li>Verify the landlord's identity and ownership documents</li>
                <li>Never make advance payments without a signed agreement</li>
                <li>Read the rental agreement carefully before signing</li>
                <li>Report any suspicious activity to PakMilkiyat</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default RentalDetail;
